export default __webpack_public_path__ + "static/media/user-agreement.6d9301bc.pdf";